import { render, staticRenderFns } from "./InvoiceOverviewTab.vue?vue&type=template&id=1dea6dd9&"
import script from "./InvoiceOverviewTab.vue?vue&type=script&lang=js&"
export * from "./InvoiceOverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceOverviewTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports